import * as React from 'react';
import PrintIcon from '../../../../assets/print';
import exportIcon from '../../../../assets/export';
import downarrowIcon from '../../../../assets/downArrow';
import EnhancedTable from 'src/components/TableInvoices';
import BackArrow from '../../../../assets/backArrow';
import './ApplyToOriginal.scss';
import Modal from 'src/components/common/Modal';
import invoiceServiceInstance from 'src/services/invoice/InvoiceService';
import RefreshIcon from '../../../../assets/refresh';
import OriginalInvoice from 'src/components/TablesAllInvoices/OriginalTable';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import CustomPaginator from 'src/components/common/CustomPaginator';
import NextIcon from '../../../../assets/next';
import InvoiceModel from 'src/model/invoice.model';
import Input from 'src/components/common/Input';
import CloseIcon from '../../../../assets/close';
import { Alert } from '@material-ui/lab';
import { IconButton } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';
interface IApplyToOriginalProps extends RouteComponentProps {
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  totalCredit: any;
  totalDebit: any;
  handlePagination: (event: any) => void;
  handlePageSizeChange?: (pageSize: number) => void;
  selectedOriginalInvoices?: InvoiceModel[];
  getOriginalInvoices?: () => void;
  setSelectedInvoices: (invoices: any) => void;
  transactionId: number[];
  selectedDebit?: number;
  selectedCredit?: number;
  orderNumber: number;
  orderlist: number[];
  invoicelist: number[];
  isDisabldBtn: boolean;
  allInvoiceNumber: [];
}
const debitErrorMessage = i18n.t('invoices.debitErrorMessage');
class ApplyToOriginal extends React.Component<IApplyToOriginalProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      showdisabledPopup: false,
      creditamount: 0,
      debitamount: 0,
      listOfOrdernumbers: [],
      listOfInvoices: [],
      isDisabldBtn: false,
      youPayAmount: 0,
      input: '',
      signature: '',
      debitCreditErrorMsg: '',
      hideAll: false,
      debitCreditUpdated: true,
      creditPage: 0,
      creditSize: 20,
      selectedCreditDebitInvoices: [],
      originalIsPending: false,
      originalInvoiceData: [],
      creditInvoiceData: [],
      currentActivePage: 0,
      pageCredit: 0,
      sizeCredit: 100,
      allTableDataArray: [],
      NewCreditInvoiceData: [],
      totalPages: 0,
      totalCredit: 0,
      totalDebit: 0,
      accumulatedDebitAmount: 0,
      totalDebitInvoice: 0,
      allInvoiceNumber: []
    };
  }
  private handleInput = (value: string) => {
    this.setState({ input: value });
  };
  public arrowBack = () => {
    this.props.history.push('/invoices');
  };
  public clickclose = () => {
    this.setState({ showdisabledPopup: false });
  };
  public getTargetpaymentsData = (listOfInvoices: any) => {
    const appliedCreditInvoices: any[] = [];
    listOfInvoices.forEach((num: any) => {
      // const details = this.props.selectedOriginalInvoices.find(
      //   newObj => newObj.invoiceNumber === num
      // );
      appliedCreditInvoices.push({
        // orderNumber: details.orderNumber,
        remainingAmount: num.remainingAmount,
        reasonRemainingBalance: '',
        transactionId: num.transactionId
      });
    });
    return appliedCreditInvoices;
  };
  public applyCredits = () => {
    this.setState({ signature: this.state.input }, () => this.clickCredit());
    this.setState({ showdisabledPopup: false });
  };
  // totalDebit: response.totalDebit,
  // totalCredit: response.totalCredit,
  public showPopup = () => {
    // if (this.state.totalDebit > this.state.totalCredit) {
    //   this.setState({
    //     debitCreditUpdated: true,
    //     isDisabldBtn: true,
    //     debitCreditErrorMsg: debitErrorMessage
    //   });
    // } else
    if (this.state.totalDebit === 0) {
      this.setState({
        debitCreditUpdated: true,
        isDisabldBtn: true,
        debitCreditErrorMsg: i18n.t(
          'invoices.youeitherdonothaveanydebitinvoicesoryouhaveinsufficientcredit'
        )
      });
    } else {
      this.setState({
        isDisabldBtn: false,
        debitCreditErrorMsg: '',
        debitCreditUpdated: true,
        showdisabledPopup: true
      });
    }
  };
  public clickCredit = () => {
    // this.props.history.push('/invoices/applyCredit');
    this.setState({
      originalIsPending: true
    });
    const paymentdata = this.getTargetpaymentsData(
      this.state.selectedCreditDebitInvoices
    );
    let creditSum = 0;
    paymentdata.forEach(obj => {
      creditSum += obj.remainingAmount;
    });
    const creditInfo = {
      signature: this.state.signature,
      totalDebit: this.state.totalDebit,
      totalCredit: this.state.totalCredit,
      creditUsed: Math.abs(creditSum)
    };
    const totalCreditUsed =
      this.state.totalDebit < this.state.totalCredit
        ? this.state.totalDebit
        : this.state.totalCredit;
    invoiceServiceInstance
      .payInvoicesByCreditsOriginal([], creditInfo)
      .then((response: any) => {
        this.setState({
          originalIsPending: false
        });
        this.props.history.push({
          pathname: '/invoices/applyCredit',
          state: {
            orderlist: this.state.selectedCreditDebitInvoices,
            creditUsed: response.data.creditUsed,
            totalDebitInvoice: response.data.noOfInvoicePaid,
            paymentId: response.data.paymentId,
            page: 'original'
          }
        });
      })
      .catch(error => {
        this.setState({
          originalIsPending: false,
          isDisabldBtn: true,
          debitCreditErrorMsg: error && error.response.data.message
        });
        // console.log('~~Eror~~' , error.response.data);
      });
  };
  // {
  //   "creditUsed": 0,
  //   "invoicePayments": [
  //     {
  //       "orderNumber": 0,
  //       "paymentAmount": 0,
  //       "reasonRemainingBalance": "string",
  //       "transactionId": 0
  //     }
  //   ],
  //   "signature": "string",
  //   "totalCredit": 0,
  //   "totalDebit": 0
  // }

  // creditUsed: null
  // id: 209
  // noOfInvoicePaid: null
  // notes: null
  // paymentDetails: [{id: 3293, paymentAmount: 2900.33, totalAmount: 2900.33, reasonRemainingBalance: null,…},…]
  // paymentId: "825014848-20201209"
  // paymentStatus: "PENDING"
  // pmtDate: "2020-12-09"
  // signature: "Testr2"
  // taker: null
  public getTargetPaymentsDataCreditCard = (listOfInvoices: number[]) => {
    const appliedCreditInvoices: any[] = [];
    listOfInvoices.forEach(num => {
      const details = this.props.selectedOriginalInvoices.find(
        newObj => newObj.invoiceNumber === num
      );

      appliedCreditInvoices.push({
        customerNumber: details.customerNumber,
        description: details.description,
        dueDate: details.dueDate,
        hasInvoice: details.hasInvoice,
        invoiceDate: details.invoiceDate,
        invoiceNumber: details.invoiceNumber,
        remainingAmount: details.remainingAmount,
        status: details.status,
        orderNumber: details.orderNumber,
        transactionId: details.transactionId
      });
    });
    return appliedCreditInvoices;
  };

  public payRemaining = () => {
    if (this.state.listOfInvoices && this.state.listOfInvoices.length > 0) {
      const paymentdata = this.getTargetPaymentsDataCreditCard(
        this.state.listOfInvoices
      );
      this.props.setSelectedInvoices(paymentdata);
      this.props.history.push({
        pathname: '/invoices/payRemaining',
        state: {
          creditAmount: this.props.totalCredit,
          debitAmount: this.state.debitamount,
          creditUsed: this.state.creditUsed,
          youPayAmount: this.state.youPayAmount,
          navigateTo: 'applyOriginal'
        }
      });
    } else {
      this.setState({
        debitCreditErrorMsg: i18n.t('invoices.debitErrorMessage2')
      });
    }
  };

  // }
  public checkboxcall = (rowsSelectedpath: any, invoiceData: any) => {
    let newDebitAmount = 0;
    let newCreditAmount = 0;
    const youPayAmount = 0;
    let numberlist: number[] = [];
    let invoicesList: number[] = [];
    rowsSelectedpath.map((index: any) => {
      if (this.props.selectedOriginalInvoices.length > 0) {
        numberlist.push(this.props.selectedOriginalInvoices[index].orderNumber);
        invoicesList.push(
          this.props.selectedOriginalInvoices[index].invoiceNumber
        );
      }
      // if (props.invoiceData.length > 0) {
      const remainingAmount = invoiceData[index].remainingAmount;
      // const pay = newDebitAmount - newDebitAmount

      if (remainingAmount >= 0) {
        newDebitAmount += remainingAmount;
      } else {
        newCreditAmount += remainingAmount;
      }

      // }
    });
    this.setState({
      creditamount: newCreditAmount,
      debitamount: newDebitAmount,
      listOfOrdernumbers: numberlist,
      listOfInvoices: invoicesList,
      youpayAmount: youPayAmount,
      debitCreditUpdated: true
    });
    numberlist = [];
    invoicesList = [];
  };
  public adjustDebitsAgainstCredits = async () => {
    // console.log('testtttttttttttttttttttttt');
    const creditArr: any[] = [...this.state.creditInvoiceData];
    // const debitArr: any[] = [...this.state.originalInvoiceData];

    const tempCurrentItems = this.state.currentActivePage * 20;
    const endPointCount = tempCurrentItems + 20;
    const debitArr: any[] = this.state.originalInvoiceData.slice(
      tempCurrentItems,
      endPointCount
    );
    // console.log('splited array',this.state.originalInvoiceData.slice(tempCurrentItems, endPointCount));

    // debugger;
    if (debitArr && debitArr.length > 0 && creditArr && creditArr.length > 0) {
      const lastUsedCreditRemaining: any[] = [];
      const creditRemaining = Object.assign(
        {},
        ...creditArr.map(item => ({
          [item.invoiceNumber]: item.remainingAmount
        }))
      );
      // console.log('creditRemaining 111~~~~',creditRemaining,lastUsedCreditRemaining);
      for (const idx of debitArr) {
        const mappedCredits = [];
        // let creditCheck: any = 0;
        let index = 0;
        let pmtAmt = 0;
        let remCAmt = 0;
        let remCAAmt = 0;
        let remCACAmt = 0;
        let cumulativeBalance = 0;
        if (creditArr && creditArr.length > 0) {
          for (const cidx of creditArr) {
            index++;
            remCAAmt = Math.abs(
              creditRemaining[cidx.invoiceNumber]
                ? creditRemaining[cidx.invoiceNumber]
                : 0
            );
            for (const didx of cidx.invoicesDetailList) {
              if (idx.invoiceNumber + '' === didx.previousInvoice + '') {
                remCAmt +=
                  remCAAmt > Math.abs(didx.paymentAmountLine)
                    ? Math.abs(didx.paymentAmountLine)
                    : remCAAmt;
              }
            }
          }
        }
        pmtAmt = remCAmt > idx.remainingAmount ? idx.remainingAmount : remCAmt;
        cumulativeBalance = pmtAmt;

        if (creditArr && creditArr.length > 0) {
          for (const cidx of creditArr) {
            index++;
            remCACAmt = Math.abs(
              creditRemaining[cidx.invoiceNumber]
                ? creditRemaining[cidx.invoiceNumber]
                : 0
            );
            for (const didx of cidx.invoicesDetailList) {
              if (idx.invoiceNumber + '' === didx.previousInvoice + '') {
                const creditMapped = JSON.parse(JSON.stringify(cidx));
                creditMapped.paymentAmountLine =
                  remCACAmt > Math.abs(didx.paymentAmountLine)
                    ? -1 * Math.abs(didx.paymentAmountLine)
                    : -1 * remCACAmt;
                creditMapped.previousInvoice = didx.previousInvoice;
                creditMapped.nardaNumber = didx.nardaNumber;
                // console.log('~~~~~~~~',cumulativeBalance,creditMapped.paymentAmountLine)
                if (remCAmt > idx.remainingAmount) {
                  //  console.log('cumulativeBalance11>>',cumulativeBalance, Math.abs(didx.paymentAmountLine/1))
                  creditMapped['remainingAmount'] =
                    cumulativeBalance >
                    Math.abs(creditMapped.paymentAmountLine / 1)
                      ? 0
                      : creditMapped.paymentAmountLine / 1 + cumulativeBalance;
                  cumulativeBalance += creditMapped.paymentAmountLine / 1;
                  creditMapped.paymentAmountLine =
                    creditMapped.paymentAmountLine / 1 +
                    Math.abs(creditMapped['remainingAmount'] / 1);
                } else {
                  creditMapped['remainingAmount'] = 0;
                }

                // console.log('creditRemaining[cidx.invoiceNumber 11>>',creditRemaining[cidx.invoiceNumber]);

                creditRemaining[cidx.invoiceNumber] =
                  creditRemaining[cidx.invoiceNumber] / 1 +
                  Math.abs(creditMapped.paymentAmountLine / 1);
                const selected = lastUsedCreditRemaining.filter(
                  a => a.cId === cidx.invoiceNumber
                );
                if (selected.length > 0) {
                  const selectedDebit: any[] = debitArr.filter(
                    b => b.invoiceNumber === selected[0]['dId']
                  );
                  if (selectedDebit.length > 0) {
                    const selectedCMapped: any[] =
                      selectedDebit[0]['mappedCredits'];
                    if (selectedCMapped !== undefined) {
                      const selectedCredit = selectedCMapped.filter(
                        c => c.invoiceNumber === cidx.invoiceNumber
                      );
                      if (selectedCredit.length > 0) {
                        selectedCredit[0]['remainingAmount'] = 0;
                      }
                    }
                  }
                }
                if (Math.abs(creditMapped['remainingAmount'] / 1) > 0) {
                  if (selected.length > 0) {
                    selected[0]['dId'] = idx.invoiceNumber;
                  } else {
                    lastUsedCreditRemaining.push({
                      cId: cidx.invoiceNumber,
                      dId: idx.invoiceNumber,
                      remAmt: creditMapped['remainingAmount']
                    });
                  }
                }
                //  console.log('creditRemaining[cidx.invoiceNumber 22>>',creditRemaining[cidx.invoiceNumber]);
                // console.log('~~~11~~~~~',cumulativeBalance,creditMapped.paymentAmountLine,creditMapped['remainingAmount'])
                mappedCredits.push(creditMapped);
              }
            }
          }
        }
        const isAlreadyPaid = mappedCredits.filter(
          a => a.status === 'PENDING' || a.status === 'IN PROCESS'
        );
        idx['label'] = isAlreadyPaid.length > 0 || mappedCredits.length === 0;
        idx['pmtAmt'] = pmtAmt;
        idx.mappedCredits = mappedCredits;
        // console.log('creditRemaining 222~~~~',creditRemaining,lastUsedCreditRemaining);
        // idx.paymentAmount = paymentAmountCtx;
        // if (creditCheck === 0) {
        //   creditArr.splice(0, creditArr.length);
        // } else {
        //   creditArr.splice(0, creditIndex);
        // }
      }
    }

    if (debitArr && debitArr.length > 0) {
      let indexVal = 0;
      for (let k = 0; k < debitArr.length; k++) {
        if (
          debitArr[k].mappedCredits &&
          debitArr[k].mappedCredits.length === 0
        ) {
          indexVal = k;
          break;
        }
      }
      if (indexVal > 0) {
        debitArr.splice(indexVal, debitArr.length);
      }
    }

    this.setState({ selectedCreditDebitInvoices: debitArr }, () => {
      const tempArray = [...this.state.allTableDataArray];
      tempArray.splice(
        this.state.currentActivePage,
        0,
        this.state.selectedCreditDebitInvoices
      );
      const allTableDataArray = tempArray;
      this.setState({
        allTableDataArray,
        NewCreditInvoiceData: creditArr
      });
    });
  };
  // totalDebit: response.totalDebit,
  // totalCredit: response.totalCredit,
  public async componentDidUpdate(prevProps: any, prevState: any) {
    //  debugger
    if (this.state.debitCreditUpdated) {
      // if (
      //   this.state.totalDebit > 0 &&
      //   this.state.totalCredit > 0 &&
      //   this.state.totalDebit > this.state.totalCredit
      // ) {
      //   this.setState({
      //     hideAll: false,
      //     debitCreditErrorMsg: debitErrorMessage,
      //     debitCreditUpdated: false
      //   });
      // } else if (this.state.totalDebit === 0 && this.state.totalCredit > 0) {
      //   this.setState({
      //     hideAll: true,
      //     debitCreditErrorMsg:
      //       'You either do not have any debit invoices, or you have insufficient credit.',
      //     debitCreditUpdated: false
      //   });
      // } else
      if (this.state.totalCredit > 0) {
        this.setState({
          hideAll: false,
          debitCreditErrorMsg: '',
          debitCreditUpdated: false
        });
      }
    }
    //  debugger
    if (
      (prevState.creditInvoiceData !== this.state.creditInvoiceData ||
        prevState.originalInvoiceData !== this.state.originalInvoiceData) &&
      this.state.creditInvoiceData.length > 0 &&
      this.state.originalInvoiceData.length > 0
    ) {
      // const remainingDebitAmt = this.state.originalInvoiceData
      //   .map((data: any) => data.remainingAmount)
      //   .reduce((a: number, b: number) => a + b, 0);
      // const remainingCreditAmt = this.state.creditInvoiceData
      //   .map((data: any) => data.remainingAmount)
      //   .reduce((a: number, b: number) => a + b, 0);
      // if (remainingDebitAmt <= Math.abs(remainingCreditAmt)) {
      //  debugger
      this.adjustDebitsAgainstCredits();
      // }
    }
  }

  public getCreditInvoiceData = async (
    invoiceNumbers: any,
    page: any,
    size: any
  ) => {
    this.setState({
      originalIsPending: true
    });
    const pagination = { page, size };
    //     console.log(pagination);
    const response: any = await invoiceServiceInstance.selectCreditOriginal(
      { listOfOriginalInvoices: invoiceNumbers },
      pagination
    );
    return response.data;
  };
  public getOriginalInvoiceData = async (
    pageNumbers: number,
    size: number = 20
  ) => {
    this.setState({
      originalIsPending: true
    });
    const pagination = { page: pageNumbers, size };
    const response: any = await invoiceServiceInstance.originalInvoice();
    return response;
  };

  public componentDidMount() {
    // this.props.getOriginalInvoices();
    const debitPromise = this.getOriginalInvoiceData(
      this.state.currentActivePage,
      20
    );
    // const creditPromise = this.getCreditInvoiceData(
    //   this.state.pageCredit,
    //   this.state.sizeCredit
    // );

    invoiceServiceInstance
      .creditDebitSummary('original')
      .then((response: any) => {
        this.setState({
          totalDebit: response.totalDebit,
          totalCredit: response.totalCredit,
          totalDebitInvoice: response.totalDebitInvoice
        });
        debitPromise.then(debits => {
          const invoiceNumbers: any = [];
          const allowedDebits: any = [];
          // let accumulatedDebit = this.state.accumulatedDebitAmount;
          // if (this.state.accumulatedDebitAmount < this.state.totalCredit) {
          debits.data.forEach((debit: any) => {
            // if (accumulatedDebit < this.state.totalCredit) {
            //  accumulatedDebit += debit.remainingAmount;
            allowedDebits.push(debit);
            invoiceNumbers.push(debit.invoiceNumber);
            // }
          });
          this.setState({
            allInvoiceNumber: invoiceNumbers
          });
          const a = invoiceNumbers.slice(this.state.currentActivePage, 200);
          // console.log('invoiceNumbers', invoiceNumbers);
          // console.log('debits.totalPages', debits.totalPages);
          // console.log('allowedDebits', allowedDebits.length);
          // }
          // debugger;
          this.getCreditInvoiceData(
            a.toString(),
            this.state.pageCredit,
            this.state.sizeCredit
          ).then(credits => {
            this.setState({
              originalInvoiceData: allowedDebits,
              totalPages: Math.ceil(allowedDebits.length / 200),
              // totalPages:debits.totalPages,
              creditInvoiceData: credits,
              originalIsPending: false
              // accumulatedDebitAmount: accumulatedDebit
            });
          });
        });
      });

    if (this.props.totalDebit === 0 || this.props.totalCredit === 0) {
      this.setState({
        isDisabldBtn: true
      });
    }
  }

  public changeCurrentPage = (info: any) => {
    if (info === 'next') {
      // console.log('invoiceNumbers',this.state.allTableDataArray);
      if (this.state.currentActivePage + 1 < this.state.totalPages) {
        this.setState(
          {
            currentActivePage: this.state.currentActivePage + 1
          },
          () => {
            this.getCreditInvoiceDataNew();
          }
        );
      }
    } else {
      if (this.state.currentActivePage >= 1) {
        this.setState({
          currentActivePage: this.state.currentActivePage - 1
        });
      }
    }
  };

  public getCreditInvoiceDataNew() {
    // console.log('getCreditInvoiceDataNew===========');
    // console.log('this.state.currentActivePage', this.state.currentActivePage);
    const tempCurrentItems = this.state.currentActivePage * 20;
    const endPointCount = tempCurrentItems + 20;
    const b = this.state.allInvoiceNumber.slice(
      tempCurrentItems,
      endPointCount
    );
    // console.log('splited array',this.state.allInvoiceNumber.slice(tempCurrentItems, endPointCount));
    // console.log('splited array==============',b);

    this.getCreditInvoiceData(
      b.toString(),
      this.state.pageCredit,
      this.state.sizeCredit
    ).then(credits => {
      // console.log('credits===========', credits);

      this.setState({
        // originalInvoiceData: this.state.originalInvoiceData,
        creditInvoiceData: credits,
        originalIsPending: false
      });
    });
  }

  public render() {
    // console.log('originalInvoiceData', this.state.originalInvoiceData);
    // console.log('allTableDataArray', this.state.allTableDataArray);
    // console.log('allTableDataArray====', this.state.allTableDataArray[0]);
    const youPayAmount =
      this.state.totalDebit < this.state.totalCredit
        ? '$0.00'
        : '$' + (this.state.totalDebit - this.state.totalCredit).toFixed(2);
    // const totalCreditUsed =
    //   this.state.debitamount < this.props.totalCredit
    //     ? '$' + this.state.debitamount.toFixed(2)
    //     : '$' + this.props.totalCredit.toFixed(2);
    const totalCreditUsed =
      this.state.totalDebit < this.state.totalCredit
        ? currencyFormatter(this.state.totalDebit)
        : currencyFormatter(this.state.totalCredit);
    return (
      <div className="apply-original-container">
        <div className="apply-original">
          <div className="d-flex ht-0">
            <img
              className="image-icon"
              onClick={this.arrowBack}
              src={BackArrow}
            />
            <div className="apply-heading">
              {i18n.t('invoices.applytoOriginal')}
            </div>
          </div>
          <div className="d-flex justify-flex-end">
            {/* <button className="cancel-btn" onClick={this.arrowBack}>
              Cancel
            </button> */}
            {!this.state.hideAll && (
              <button
                className="btn"
                onClick={this.showPopup}
                // disabled={this.state.isDisabldBtn}
              >
                {i18n.t('invoices.applyCredits')}
              </button>
            )}

            {/* <button className="btn" onClick={this.payRemaining}>
              Pay
            </button> */}
          </div>
        </div>
        <div className="d-flex summary-container">
          <div className="d-flex invoices-used">
            <span className="summary">{i18n.t('invoices.summary')}</span>
            <div className="d-flex margin">
              <span className="open-invoices">
                {i18n.t('invoices.totalDebit')}{' '}
              </span>
              <span className="credit-amount1">
                {/* {'$' + this.state.debitamount.toFixed(2)} */}
                {currencyFormatter(this.state.totalDebit)}
              </span>
            </div>

            <div className="d-flex margin">
              <span className="open-invoices">
                {i18n.t('invoices.totalCredit')}{' '}
              </span>
              <span className="credit-amount">
                {' '}
                {/* {'$' + this.props.totalCredit.toFixed(2)} */}
                {currencyFormatter(this.state.totalCredit)}
              </span>
            </div>
            <div className="d-flex credit-used margin">
              <span className="open-invoices ">
                {' '}
                {i18n.t('invoices.creditUsed')}{' '}
              </span>
              <span className="credit-amount">{totalCreditUsed}</span>
            </div>
          </div>
          <div className="w-2" />
          <div className="total-pay d-flex">
            {/* <div className="margin">
              <span className="margin-rt">You Pay</span>
              <span className="credit-amount">{youPayAmount}</span>
            </div>
            <div>
              <img className="next-arrow" src={NextIcon} />
            </div> */}
          </div>
        </div>
        <br />
        {this.state.debitCreditErrorMsg &&
          this.state.debitCreditErrorMsg.length > 0 && (
            <>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      this.setState({ debitCreditErrorMsg: '' });
                    }}
                  >
                    <MatrialCloseIcon fontSize="inherit" />
                  </IconButton>
                }
                severity="error"
              >
                {this.state.debitCreditErrorMsg}
              </Alert>
              <br />
            </>
          )}
        <div>
          <OriginalInvoice
            invoiceData={
              this.state.allTableDataArray[this.state.currentActivePage]
            }
            isChecked={this.checkboxcall}
            hideAll={this.state.hideAll}
            originalIsPending={this.state.originalIsPending}
            totalPages={this.state.totalPages}
            currentActivePage={this.state.currentActivePage}
            changeCurrentPage={this.changeCurrentPage}
          />
        </div>
        {this.state.showdisabledPopup ? (
          <div>
            <Modal handleCloseModal={() => console.log('Modal closed')}>
              <div className="apply-original-modal">
                <div className="d-flex justify-space-bw">
                  <div className="modal-label">
                    <b>{i18n.t('invoices.applyingCredit')}</b>
                  </div>
                  <div className="close-icon" onClick={this.clickclose}>
                    <img src={CloseIcon} />
                  </div>
                </div>
                <div className="modal-content">
                  {i18n.t('invoices.toPay')} {totalCreditUsed}{' '}
                  {i18n.t(
                    'invoices.usingyourcredityoumustprovideyoursignature'
                  )}
                </div>
                <Input
                  label="Enter your Full Name"
                  onChange={this.handleInput}
                  value={this.state.input}
                  className="rp-forgotpassword--input"
                />
                <div className="text-align-center">
                  <button className="ok-btn mr-20" onClick={this.clickclose}>
                    {i18n.t('common.cancel')}
                  </button>
                  <button className="ok-btn" onClick={this.applyCredits}>
                    {i18n.t('common.continueActionTxt')}
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default ApplyToOriginal;
